<template>
  <calm-page class="ttype" eyebrow="Transaction Type">
    <template slot="title">{{ $t("lmg.ttype") }}</template>
    <template slot="sub">
      <span><strong class="c-mono">{{ total }}</strong> {{ $t("lmg.ttype") }}</span>
    </template>
    <template slot="actions">
      <calm-button variant="primary" @click="handleCreate()">
        <i class="fas fa-plus mr-1"></i> {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ TABLE CARD ═══════════════ -->
    <calm-table>
      <template slot="toolbar">
        <input
          v-model="searchQuery"
          type="text"
          class="ed ttype-search"
          :placeholder="$t('search')"
        />
        <div class="calm__tfoot__per">
          <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-primary"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </template>

      <!-- skin, don't rewrite: the existing el-table + columns kept verbatim -->
      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          v-bind="column"
        >
        </el-table-column>

        <el-table-column :label="$t(`status`)">
          <div slot-scope="{ $index, row }" class="d-flex">
            <template v-if="row.IsActive == 1">
              {{ $t("status_active") }}</template
            >
            <template v-else>{{ $t("status_not_active") }}</template>
          </div>
        </el-table-column>

        <el-table-column
          min-width="200px"
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ $index, row }" class="d-flex">
            <base-button
              @click.native="handleEdit($index, row)"
              class="edit"
              type="warning"
              size="sm"
              icon
            >
              <i class="text-dtac-bt fa fa-edit"></i>
            </base-button>
            <!-- <base-button
              @click.native="handleDelete($index, row)"
              class="remove btn-link"
              type="danger"
              size="sm"
              icon
            >
              <i class="text-dtac-bt fa fa-trash"></i>
            </base-button> -->
          </div>
        </el-table-column>
      </el-table>

      <div
        class="calm__tfoot ttype-foot"
        v-if="tableData.length != 0"
      >
        <div class="calm__tfoot__count">
          {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
          {{ $t("of") }}
          {{ total }}
          <span v-if="selectedRows.length">
            - &nbsp; &nbsp; {{ selectedRows.length }}
            {{ $t("row_select") }}
          </span>
        </div>
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>
    </calm-table>

    <!-- ═══════════════ ADD / EDIT MODAL ═══════════════ -->
    <calm-modal
      :show.sync="showAddModal"
      :title="$t('lmg.ttype')"
      :show-footer="false"
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form
          class="new-event--form"
          @submit.prevent="handleSubmit(onUpdateTtype)"
        >
          <base-input
            :label="$t('name')"
            v-model="md.Name"
            :name="$t('name')"
            rules="required"
          >
          </base-input>

           <base-input
            :label="$t(`lmg.code`)"
            input-classes="form-control-alternative new-event--title"
          >
            <el-select v-model="md.CodeID" :placeholder="$t('lmg.code')">
              <el-option
                v-for="option in tableCode"
                :key="option.ID"
                :label="option.Code"
                :value="option.ID"
                rules="required"
              >
              </el-option>
            </el-select>
          </base-input>



          <base-input
            :label="$t('detail')"
            v-model="md.Detail"
            :name="$t('detail')"
            rules="required"
          >
          </base-input>

          <base-input
            :label="$t(`status`)"
            input-classes="form-control-alternative new-event--title"
            v-if="md.ID != 0"
          >
            <el-select v-model="md.IsActive" :placeholder="$t('status')">
              <el-option
                v-for="option in activeStatus"
                :key="option.ID"
                :label="option.Name"
                :value="option.ID"
              >
              </el-option>
            </el-select>
          </base-input>

          <div class="calm__modal__actions ttype-modal-actions">
            <calm-button variant="ghost" type="button" @click="showAddModal = false">
              {{ $t("close") }}
            </calm-button>
            <calm-button variant="primary" native-type="submit">
              {{ $t("save") }}
            </calm-button>
          </div>
        </form>
      </validation-observer>
    </calm-modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Ttype/getData",
      tableCode: "Ttype/getCode"
    }),
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    },
    tableColumns: function() {
      return [
        // {
        //   prop: "BranchName",
        //   label: this.$t("lmg.branch"),
        //   minWidth: 90,
        //   sortable: true
        // },
        {
          prop: "Name",
          label: this.$t("lmg.insure"),
          minWidth: 140,
          sortable: true
        },
        {
          prop: "Code",
          label: this.$t("lmg.code"),
          minWidth: 120,
          sortable: true
        },
        {
          prop: "Detail",
          label: this.$t("detail"),
          minWidth: 300,
          sortable: true
        }
      ];
    }
  },
  data() {
    return {
      propsToSearch: ["BranchName", "Name"],
      selectedRows: [],
      showAddModal: false,
      md: {
        ID: "",
        BranchName: "",
        BranchID: 0,
        CodeID: "",
        Name: "",
        Detail: "",
        IsActive: 1
      },
      activeStatus: [
        {
          ID: 1,
          Name: "ใช้งาน"
        },
        {
          ID: 0,
          Name: "ไม่ใช้งาน"
        }
      ]
    };
  },
  mounted() {
    this.listData();
    this.listCode();
  },
  methods: {
    ...mapActions({
      createData: "Ttype/createData",
      updateData: "Ttype/updateData",
      deleteData: "Ttype/deleteData",
      listData: "Ttype/listData",
      listCode: "Ttype/listCode"
    }),
    handleCreate() {
      this.showAddModal = true;
      this.$refs.formValidator.reset();
      this.md.ID = 0;
      this.md.BranchName = "";
      this.md.BranchID = "";
      this.md.Name = "";
      this.md.Detail = "";
      this.md.IsActive = "";
      this.md.CodeID = "";
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.ID = row.ID;
      this.md.BranchName = row.BranchName;
      this.md.BranchID = row.BranchID;
      this.md.Name = row.Name;
      this.md.Detail = row.Detail;
      this.md.IsActive = row.IsActive;
      this.md.CodeID = row.CodeID
    },
    onUpdateTtype() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData({
          name: this.md.Name,
          detail: this.md.Detail,
          codeID : this.md.CodeID == "" ? 0 : this.md.CodeID
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      } else {
        // update

        this.updateData({
          ID: this.md.ID,
          name: this.md.Name,
          detail: this.md.Detail,
          branchID: this.md.BranchName,
          isActive: this.md.IsActive,
          codeID : this.md.CodeID == "" ? 0 : this.md.CodeID
        })
          .then(resp => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              id: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
/* Namespaced + scoped: chrome-only tweaks for the Ttype Calm page.
   Does not affect any other page. */
.ttype .ttype-search {
  width: 240px;
  max-width: 100%;
}
.ttype .calm__table-head__tools {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.ttype .ttype-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.ttype .ttype-modal-actions {
  margin-top: 18px;
}
</style>
